<template>
  <div class="gifContainer">
    <img class="gif" :src="link" />
  </div>
</template>



<script>
import jQuery from "jquery";
import ReRenderer from "../../mixins/re-renderer.vue";

export default {
  mixins: [ReRenderer],
  components: {},
  props: ["link"],
  data() {
    return {
      reRenderCssSelectors: [
        {
          jquerySelectors: ".gifContainer",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
      ],
    };
  },
  computed: {},
  mounted() {
    jQuery(document).ready(function () {
      jQuery(".gifContainer").css("height", jQuery(window).height() + "px");
    });
  },
};
</script>



<style scoped>
.gifContainer {
  height: 850px;
  width: 500px;
  position: relative;
  /* white-space: nowrap; */
}

.gif {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  /* object-fit: cover; */
  width: 100%;
  object-fit: cover;
  max-height: 90vh;
  /* vertical-align: middle; */
}

@media only screen and (max-width: 499px) {
  .gifContainer {
    /* height: 844; */
    width: 500px;
    position: relative;
    /* white-space: nowrap; */
  }

  .gif {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    /* object-fit: cover; */
    width: 100%;
    /* vertical-align: middle; */
  }
}
</style>
